import React from "react";
import { Icon } from "../icons";
import { fmtReminderWhen, reminderSortKey, todayStr } from "../lib/format";
import { useMcOps } from "../lib/McOpsContext";
import { ReminderForm } from "./ReminderForm";

const Row = ({ reminder, onDone, onOpen }) => (
  <div
    className={`reminder-item${reminder.jobId ? " clickable" : ""}`}
    style={{
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: 8,
    }}
    onClick={() => reminder.jobId && onOpen(reminder.jobId)}
    title={reminder.jobId ? "Open the job" : undefined}
  >
    <div>
      {reminder.text}
      <div className="meta">
        {reminder.jobLabel ? reminder.jobLabel + " · " : ""}
        {fmtReminderWhen(reminder)}
      </div>
    </div>
    <button
      className="btn small"
      onClick={(e) => {
        e.stopPropagation();
        onDone(reminder.id);
      }}
    >
      <Icon name="check" />
      Done
    </button>
  </div>
);

export const ReminderHubModal = () => {
  const { state, reminderHubOpen, closeReminderHub, completeReminder, openJob } = useMcOps();
  const todayD = todayStr();

  if (!reminderHubOpen) return null;

  const active = state.reminders
    .filter((r) => !r.completed)
    .sort((a, b) => reminderSortKey(a).localeCompare(reminderSortKey(b)));
  const overdue = active.filter((r) => r.date < todayD);
  const dueToday = active.filter((r) => r.date === todayD);
  const upcoming = active.filter((r) => r.date > todayD);

  const group = (label, list, color) =>
    list.length ? (
      <React.Fragment key={label}>
        <div className="section-label" style={color ? { color } : undefined}>
          {label}{" "}
          <span
            className="meta"
            style={{ textTransform: "none", fontWeight: 600, color: "var(--ink-400)" }}
          >
            ({list.length})
          </span>
        </div>
        {list.map((r) => (
          <Row
            reminder={r}
            onDone={completeReminder}
            onOpen={(jobId) => {
              closeReminderHub();
              openJob(jobId);
            }}
            key={r.id}
          />
        ))}
      </React.Fragment>
    ) : null;

  return (
    <div
      className="modal-overlay open"
      onClick={(e) => {
        if (e.target === e.currentTarget) closeReminderHub();
      }}
    >
      <div className="modal" style={{ maxWidth: 600 }}>
        <div className="modal-head">
          <div className="mh-left">
            <div className="mh-avatar" style={{ background: "var(--grad-primary)" }}>
              <Icon name="bell" />
            </div>
            <div>
              <h3>Reminders</h3>
              <div className="meta">
                {active.length} active
                {overdue.length ? " · " + overdue.length + " overdue" : ""}
              </div>
            </div>
          </div>
          <button className="modal-close" onClick={closeReminderHub}>
            <Icon name="x" />
          </button>
        </div>

        <div className="modal-body">
          <div className="section-label">
            <Icon name="bell" />
            New Reminder
          </div>
          <ReminderForm compact />

          {group("Overdue", overdue, "var(--danger)")}
          {group("Due Today", dueToday)}
          {group("Upcoming", upcoming)}
          {!active.length ? (
            <div className="panel-empty">No reminders yet — add one above.</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
